import { Component, OnInit, Input } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { Product } from 'src/app/models/interface/product/product';

@Component({
  selector: 'app-product-map',
  templateUrl: './product-map.component.html',
  styleUrls: ['./product-map.component.scss']
})
export class ProductMapComponent implements OnInit {

  @Input() item: Product;
  @Input() params: any;

  constructor() { }

  ngOnInit() {
  }

}
